/**
 * ticketsApi.js - the Tickets page's calls (server/routes/tickets.js,
 * /api/tickets). Each answers { ok, status, body } and never throws.
 */
import { json, send, qs } from '../../utils/api';

export { errorOf } from '../../utils/api';

const BASE = '/api/tickets';

export const listTickets = (params) => json(`${BASE}${qs(params)}`);
export const getTicket = (id) => json(`${BASE}/${encodeURIComponent(id)}`);
export const updateTicket = (id, patch) => json(`${BASE}/${encodeURIComponent(id)}`, send('PATCH', patch));
export const ticketSummary = () => json(`${BASE}/summary`);
export const myTickets = () => json(`${BASE}/mine`);

/** Add files to a ticket (Tickets Edit). Answers body.files: the new rows, each with its url. */
export function addTicketFiles(id, files) {
  const fd = new FormData();
  for (const f of files) fd.append('files', f, f.name || 'file');
  return json(`${BASE}/${encodeURIComponent(id)}/files`, { method: 'POST', body: fd });
}
export const removeTicketFile = (id, fileId) =>
  json(`${BASE}/${encodeURIComponent(id)}/files/${encodeURIComponent(fileId)}`, { method: 'DELETE' });

/** A ticket file as a same-origin blob URL (a raw link cannot carry the sign-in token), or null. */
export async function fileBlobUrl(url, inline) {
  try {
    const r = await fetch(`${url}${inline ? '?inline=1' : ''}`);
    if (!r.ok) return null;
    return URL.createObjectURL(await r.blob());
  } catch {
    return null;
  }
}
